<template>
  <div id="home">
    <img class="top-image" src="../assets/top-image.png"/>
    <div class="title">
      <h1>
        Tienes un regalo especial esperando a ser descubierto ¿Qué será? ¿Se comerá?<br/><br/>

        Encuentra las letras o números escondidos por la casa para poder desbloquear el premio<br/>
        <b>¡Suerte!</b>
      </h1>
    </div>
    <div class="questions-container">
      <div class="question">
        <div class="hint">
          <p><span>Pista 1:</span>{{ hints[0] }}</p>
        </div>
        <div class="field">
          <p class="control">
            <input class="input" type="text" v-model.number="answers[0]"/>
          </p>
        </div>
      </div>
      <div class="question">
        <div class="hint">
          <p><span>Pista 2:</span>{{ hints[1] }}</p>
        </div>
        <div class="field">
          <p class="control">
            <input class="input" type="text" v-model.number="answers[1]"/>
          </p>
        </div>
      </div>
      <div class="question">
        <div class="hint">
          <p><span>Pista 3:</span>{{ hints[2] }}</p>
        </div>
        <div class="field">
          <p class="control">
            <input class="input" type="text" v-model.number="answers[2]"/>
          </p>
        </div>
      </div>
      <div class="question">
        <div class="hint">
          <p><span>Pista 4:</span>{{ hints[3] }}</p>
        </div>
        <div class="field">
          <p class="control">
            <input class="input" type="text" v-model="answers[3]"/>
          </p>
        </div>
      </div>
    </div>
    <button v-if="!winReward" class="button is-info" @click="checkAnswers">Probar suerte</button>
    <div class="reward" v-if="winReward">
      <p>{{messageWin}}</p>
      <a class="button is-info" href="../Vale-viajero.pdf" target="_blank">REGALO 1</a>
      <a class="button is-info" href="../Vale-surf.pdf" target="_blank">REGALO 2</a>
      <a class="button is-success" :href="youtubeUrl" target="_blank">
        <span class="icon is-small">
          <i class="fas fa-play"></i>
        </span>
        <span>REGALO FINAL</span>
      </a>
    </div>
    <div class="fail" v-if="messageFail">
      <p>{{messageFail}}</p>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src

  export default {
    name: "Home",
    data() {
      return {
        hints: [
          ' Objeto olvidado con el cual llegó tu caballero' +
          '            salvador el primer día en el que le conociste',
          ' ¿Y ese olor? Qué mezcla tan poco agradable' +
          '            para una ocasión tan señalada',
          ' De escapada al extranjero, ñam ñam, qué regalo' +
          ' más rico compraste para alguien que nunca lo recibió ',
          ' Lugar de oración de tu miembro de la casa favorito'
        ],
        answers: [null, null, null, ""],
        winReward: null,
        messageWin: '',
        messageFail: '',
        youtubeUrl: 'https://www.youtube.com/watch?v=obu6Ih75Kug'
      };
    },
    methods: {
      checkAnswers() {
        if (
          this.answers[0] === 4 &&
          this.answers[1] === 1 &&
          this.answers[2] === 3 &&
          this.answers[3].toLowerCase() === 'x'
        ) {
          this.winReward = true;
          this.messageWin = '¡Toma! ¡Lo has conseguido! Aquí tienes tu regalo:';
          this.messageFail = '';
          return;
        }
        this.winReward = false;
        this.messageWin = '';
        this.messageFail = '¡Ups! Me da que no lo has metido bien'
      },
    }
  };
</script>
